import { defineEntity, entity, foreign, object, string } from '~/prix'

const cnaeGroup = defineEntity({
  key: 'cnaeGroup',
  title: 'Grupo de cnae',
  sources: ['olap', 'oltp'],
  schema: object({
    id: string().label('ID'),
    ibgeCode: string().label('Código IBGE'),
    description: string().label('Descrição'),
    observations: string().label('Observações'),
    cnaeDivisionId: foreign(entity('cnaeDivision').property('id')),
  }),
})

export default cnaeGroup
